var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// src/application/hooks/useCompanyRefresher.ts
import { useEffect, useRef } from 'react';
import { useAuthStore } from '../application/stores/auth.store';
import { useCompanyStore } from '../application/stores/company.store';
import { getCompanyInfoV2 } from '../application/usecases/getCompanyInfoV2';
import { DocumentStatus } from '../types/DocumentationTypes';
import { log } from '../utils/logger';
export const useCompanyRefresher = () => {
    const { isAuthenticated, companyId } = useAuthStore();
    const { company, setCompany } = useCompanyStore();
    const refreshIntervalRef = useRef(null);
    useEffect(() => {
        const shouldStartInterval = isAuthenticated && companyId && (company === null || company === void 0 ? void 0 : company.documentGenerationStatus) === DocumentStatus.GENERATING;
        if (shouldStartInterval && !refreshIntervalRef.current) {
            refreshIntervalRef.current = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const updatedCompany = yield getCompanyInfoV2(companyId);
                    setCompany(updatedCompany);
                    if (updatedCompany.documentGenerationStatus !== DocumentStatus.GENERATING) {
                        clearInterval(refreshIntervalRef.current);
                        refreshIntervalRef.current = null;
                    }
                }
                catch (error) {
                    log.error('Error refrescando información de la compañía:', error);
                }
            }), 3 * 1000); // 3 segundos
        }
        return () => {
            if (refreshIntervalRef.current) {
                clearInterval(refreshIntervalRef.current);
                refreshIntervalRef.current = null;
            }
        };
    }, [isAuthenticated, companyId, company === null || company === void 0 ? void 0 : company.documentGenerationStatus, setCompany]);
};
